module.exports = __webpack_public_path__ + "static/media/givenchy-ange-ou-demon-big.26f65457.png";